import { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import entertainment_entity_json from '../../assets/json/entertainment_entity.json';
import EntertainmentEntityManager from '../../components/EntertainmentEntityManagement/EntertainmentEntityManager';
import { clearEntityData, getEntitiesRequest, getEntityGlobalsRequest } from '../../redux/actions/getEntity';

function EntertainmentEntityManagement(props) {

  //console.log("props EE : ", props)
  const navigate = useNavigate();
  const location = useLocation();
  const passedState = location.state;
  const isNestedRoute = location.pathname !== "/entertainment-entity-management";

  const hasFetchedEntityGlobals = useRef(false);
  const hasFetchedEntities = useRef(false);
  const hasFetchedEntitiesFilter = useRef(false);

  const LIMIT = 100;
  const [fetchedPages, setFetchedPages] = useState(new Set([1]));
  const [currentPage, setCurrentPage] = useState(1);

  const [paginationData, setPaginationData] = useState(props?.GAMES_PAGINATION_DATA || {});
  const totalPages = paginationData?.totalPages || 1;

  const scrollRef = useRef(null);

  //const { entertainment_entity_filter } = entertainment_entity_json;
  const [entertainment_entity_filter, setEntertainmentEntityFilter] = useState(null);
  const [entertainment_entity_data, setEntertainmentEntity] = useState([]);
  const [searchText, setSearchText] = useState('');

  const [showFilter, setShowFilter] = useState(null);
  const [applyFilter, setApplyFilter] = useState(false);

  const [entityType, setEntityType] = useState(null);
  const [languageFilter, setLanguageFilter] = useState(null);
  const [countryFilter, setCountryFilter] = useState(null);
  const [industryFilter, setIndustryFilter] = useState(null);
  const [artistTypeFilter, setArtistTypeFilter] = useState(null);
  const [year, setYear] = useState(null);

  useEffect(() => {
    props?.getEntities({ page: 1, limit: LIMIT });
  }, []);

  useEffect(() => {
    const shouldFetch = (passedState?.shouldRefresh);
    console.log("shouldFetch : ", shouldFetch)
    console.log("passedState : ", passedState)
    if (shouldFetch) {
      setCurrentPage(1);
      setFetchedPages(new Set([1]));
      setEntertainmentEntity([]);

      props?.getEntities({
        page: 1,
        limit: LIMIT,
        displayName: '',
        type: '',
        language: '',
        country: '',
        industry: '',
        artistTypeFilter: '',
        year: ''
      });
    }

    window.history.replaceState({}, document.title);
  }, [passedState])

  const handleScroll = useCallback(() => {
    const container = scrollRef.current;
    if (!container) return;

    const isBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 100;

    // console.log("paginationData : ",paginationData)
    // console.log("isBottom : ",isBottom)
    // console.log("currentPage : ",currentPage)
    // console.log("totalPages : ",totalPages)
    // console.log("!fetchedPages.has(currentPage + 1) : ",!fetchedPages.has(currentPage + 1))
    if (isBottom && currentPage < totalPages && !fetchedPages.has(currentPage + 1)) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      setFetchedPages(prev => new Set(prev).add(nextPage));

      console.log("nextPage : ", nextPage)
      props?.getEntities({
        page: nextPage,
        limit: LIMIT,
        displayName: searchText,
        type: entityType,
        language: languageFilter,
        country: countryFilter,
        industry: industryFilter,
        artistTypeFilter: artistTypeFilter,
        year: year
      });
    }
  }, [scrollRef, currentPage, totalPages, fetchedPages, props, searchText, entityType, languageFilter, countryFilter, industryFilter, artistTypeFilter, year]);

  useEffect(() => {
    props?.getEntities({ page: 1, limit: LIMIT });
  }, []);

  useEffect(() => {
    if (!hasFetchedEntityGlobals.current && !props?.ENTITY_GLOBALS_DATA && !props?.ENTITY_GLOBALS_ERROR) {
      hasFetchedEntityGlobals.current = true;
      props?.getEntityGlobals();
    }
    else {
      setEntertainmentEntityFilter(props?.ENTITY_GLOBALS_DATA);
    }
  }, [props?.ENTITY_GLOBALS_DATA, props?.ENTITY_GLOBALS_ERROR]);

  useEffect(() => {
    const container = scrollRef.current;
    if (container) container.addEventListener('scroll', handleScroll);

    if (props?.ENTITIES_DATA) {
      console.log("ENTITIES_PAGINATION_DATA : ", props?.ENTITIES_PAGINATION_DATA)
      setPaginationData(props?.ENTITIES_PAGINATION_DATA || {});

      setEntertainmentEntity(prevEntities => {
        const merged = [...prevEntities, ...props.ENTITIES_DATA];
        const unique = Array.from(new Map(merged.map(item => [item._id, item])).values());
        return unique;
      });
    }

    return () => {
      if (container) container.removeEventListener('scroll', handleScroll);
    };
  }, [props?.ENTITIES_DATA, props?.ENTITIES_PAGINATION_DATA, handleScroll]);

  // When filter is applied
  useEffect(() => {
    if (applyFilter) {
      setCurrentPage(1);
      setFetchedPages(new Set([1]));
      setEntertainmentEntity([]);

      props?.getEntities({
        page: 1,
        limit: LIMIT,
        displayName: searchText,
        type: entityType,
        language: languageFilter,
        country: countryFilter,
        industry: industryFilter,
        artistTypeFilter: artistTypeFilter,
        year: year
      });

      setApplyFilter(false);
    }
  }, [applyFilter]);

  // Trigger this when filters clear
  const handleClearFilters = () => {
    setSearchText('');
    setEntityType(null);
    setLanguageFilter(null);
    setCountryFilter(null);
    setIndustryFilter(null);
    setArtistTypeFilter(null);
    setYear(null);

    setCurrentPage(1);
    setFetchedPages(new Set([1]));
    setEntertainmentEntity([]);

    props?.getEntities({
      page: 1,
      limit: LIMIT,
      displayName: '',
      type: '',
      language: '',
      country: '',
      industry: '',
      artistTypeFilter: '',
      year: ''
    });
  };

  const handleClearSearch = () => {
    setSearchText('');

    setCurrentPage(1);
    setFetchedPages(new Set([1]));
    setEntertainmentEntity([]);

    props?.getEntities({
      page: 1,
      limit: LIMIT,
      displayName: '',
      type: entityType,
      language: languageFilter,
      country: countryFilter,
      industry: industryFilter,
      artistTypeFilter: artistTypeFilter,
      year: year
    });
  };

  const navigateToUpdateEntity = (_entity_data) => {
    navigate('/entertainment-entity-management/create-entertainment-entity', {
      state: {
        entity_data: _entity_data,
        entertainment_entity_filter: entertainment_entity_filter,
        from: 'EntertainmentEntityManagement'
      }
    });
  };

  const navigateToCreateEntity = () => {
    //console.log("Clearing entity data...");
    //props?.clearEntityData();
    navigate('/entertainment-entity-management/create-entertainment-entity', {
      state: {
        entity_data: null,
        entertainment_entity_filter: entertainment_entity_filter,
        from: 'EntertainmentEntityManagement'
      }
    });
  };


  const handleShowFilter = () => {
    setShowFilter(!showFilter)
  };

  const handleCreateUpdateClick = (_entity_data) => {
    navigateToUpdateEntity(_entity_data);
  };

  const handleSearch = () => {
    setCurrentPage(1);
    setFetchedPages(new Set([1]));
    setEntertainmentEntity([]);

    props?.getEntities({
      page: 1,
      limit: LIMIT,
      displayName: searchText,
      type: entityType,
      language: languageFilter,
      country: countryFilter,
      industry: industryFilter,
      artistTypeFilter: artistTypeFilter,
      year: year
    });
  }

  return (
    isNestedRoute ? (
      <div style={styles.container}>
        <Outlet />
      </div>
    ) : (
      <div style={styles.container}>
        {entertainment_entity_data && <EntertainmentEntityManager
          scrollRef={scrollRef}
          entertainment_entity_data={entertainment_entity_data}
          entertainment_entity_filter={entertainment_entity_filter}
          setEntertainmentEntity={setEntertainmentEntity}
          searchText={searchText}
          setSearchText={setSearchText}
          handleCreateUpdateClick={handleCreateUpdateClick}
          onCreateClick={navigateToCreateEntity}
          handleShowFilter={handleShowFilter}
          showFilter={showFilter}
          setShowFilter={setShowFilter}
          applyFilter={applyFilter}
          setApplyFilter={setApplyFilter}
          entityType={entityType}
          setEntityType={setEntityType}
          languageFilter={languageFilter}
          setLanguageFilter={setLanguageFilter}
          countryFilter={countryFilter}
          setCountryFilter={setCountryFilter}
          industryFilter={industryFilter}
          setIndustryFilter={setIndustryFilter}
          artistTypeFilter={artistTypeFilter}
          setArtistTypeFilter={setArtistTypeFilter}
          year={year}
          setYear={setYear}
          handleSearch={handleSearch}
          handleClearSearch={handleClearSearch}
          handleClearFilters={handleClearFilters}
        />}
      </div>
    ))
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: '100vh',
    padding: '40px 0px',
    textAlign: 'center',
    boxSizing: 'border-box',
    overflow: 'hidden'
  },
  title: {
    fontSize: '36px',
    marginBottom: '10px',
  },
};

const mapStateToProps = (state) => {
  return {
    ENTITY_GLOBALS_LOADING: state?.getEntity?.entity_globals_loading,
    ENTITY_GLOBALS_DATA: state?.getEntity?.entity_globals_data,
    ENTITY_GLOBALS_ERROR: state?.getEntity?.entity_globals_error,
    ENTITIES_LOADING: state?.getEntity?.entities_loading,
    ENTITIES_ERROR: state?.getEntity?.entities_error,
    ENTITIES_DATA: state?.getEntity?.entities_data,
    ENTITIES_PAGINATION_DATA: state?.getEntity?.entities_meta,
  }
};

const mapDispatchToProps = {
  getEntities: getEntitiesRequest,
  getEntityGlobals: getEntityGlobalsRequest,
  clearEntityData,
};

export default connect(mapStateToProps, mapDispatchToProps)(EntertainmentEntityManagement);